import Model from '@/models/Model.js';

export default class PodcastActivityTemplate extends Model {
    static entity = 'podcast_activity_templates';

    static fields() {
        return {
            id: this.attr(null),
            content: this.attr(null),
            generation_context: this.attr(null),
            podcast_length: this.attr('STANDARD'),
            podcast_focus: this.attr(null),

            ...super.fields(),

            activity_template: this.morphOne('activity_templates', 'contentable_id', 'contentable_type_entity'),
        };
    }
}
